export default __webpack_public_path__ + "static/media/hht2_home_img_EP11.5738b8ff.png";